import { render } from "./SaleShareCard.vue?vue&type=template&id=1f56cffc&scoped=true"
import script from "./SaleShareCard.vue?vue&type=script&lang=js"
export * from "./SaleShareCard.vue?vue&type=script&lang=js"

import "./SaleShareCard.vue?vue&type=style&index=0&id=1f56cffc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f56cffc"]])

export default __exports__